module.exports = __webpack_public_path__ + "images/emoji/rainbow.bf9374471a61ea3292ff.png";